import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { serviceKeys, servicesApi } from "./api";
import type { ServiceCreate } from "./types";

export function useServices() {
  return useQuery({ queryKey: serviceKeys.list(), queryFn: servicesApi.list });
}

export function useSaveService() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ payload, isNew }: { payload: ServiceCreate; isNew: boolean }) =>
      isNew ? servicesApi.register(payload) : servicesApi.update(payload.audience, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: serviceKeys.all }),
  });
}

export function useSetServiceEnabled() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ audience, enabled }: { audience: string; enabled: boolean }) =>
      servicesApi.setEnabled(audience, enabled),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: serviceKeys.all }),
  });
}
